export enum userRoles {
  ADMIN = 'admin,modeler',
  MODELER = 'modeler',
  ORDINARY = 'ordinary',
  VIEWER = 'viewer',
  ENUMERATOR = 'enumerator',
  TASK_ASSIGNEE = 'taskAssignee'
}

export interface User {
  id: string | number;
  roles: string;
  name: string;
  groupId: number;
  active: boolean;
  email?: string | null;
}

export type Users = User[];

export interface ShareUser {
  email: string;
  fullNames?: string;
  accessUntil?: string;
  emailBody: string;
  create: boolean;
  roles: 'enumerator' | 'viewer';
}

export interface MittariRegistrationDetails {
  userName: string;
  password: string;
  accountName: string;
  googleSignIn: boolean;
}

export interface ActivationInterface {
  userName: string;
  activationID: string;
}
